const { createBreakpoints } = require('./breakpoints');

exports.createBreakpoints = createBreakpoints;
